import * as React from "react";
import Svg, { Rect, G, Path, Defs, ClipPath } from "react-native-svg";

const PartersCitymallIcon = (props) => (
  <Svg
    width={63}
    height={47}
    viewBox="0 0 63 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Rect
      x={16}
      width={47}
      height={47}
      rx={12}
      fill="#E40046"
      fillOpacity={0.1}
    />
    <G clipPath="url(#clip0_1_3)">
      <Path
        d="M54.9998 32.0917H47.5234V28.541H46.1633V32.0917H38.1318C38.1857 31.9949 38.228 31.9184 38.2675 31.8438C39.2837 30.0232 40.2344 28.175 40.965 26.2125C42.1673 22.9775 40.7789 19.9232 38.6623 18.2943C38.581 18.2314 38.4983 18.1069 38.4978 18.0106C38.4882 16.0902 38.4906 14.1698 38.4916 12.2485C38.4916 12.2001 38.4993 12.1555 38.5055 12.0878H41.9855V10.3616H51.5559V12.0713H54.9989L54.9998 32.0917ZM50.9524 18.1345H47.9038V19.4719H50.9524V18.1345ZM50.9432 26.334V24.9913H47.9014V26.336L50.9432 26.334ZM45.7824 19.4748V18.1282H42.7276V19.4748H45.7824ZM45.7867 24.9904H42.7285V26.3321H45.7867V24.9904ZM47.898 15.9948H50.9471V14.6618H47.898V15.9948ZM47.898 22.8579H50.9495V21.5385H47.8994L47.898 22.8579ZM45.7819 14.6691H42.7329V15.9967H45.7819V14.6691ZM42.7252 22.8594H45.781V21.5327H42.7252V22.8594Z"
        fill="white"
      />
      <Path
        d="M52.919 33.4819H52.6011C46.4613 33.4819 40.3215 33.4801 34.1817 33.4766C33.9624 33.4766 33.845 33.5478 33.7296 33.7322C32.8668 35.1001 31.9915 36.4598 31.1191 37.8214C31.085 37.8746 31.0446 37.9235 30.9883 38C30.5444 37.3265 30.1044 36.6752 29.6807 36.0148C28.2432 33.7715 26.8769 31.486 25.6938 29.0945C25.1167 27.9257 24.579 26.7364 24.2409 25.4707C23.6571 23.2841 24.1553 21.3095 25.5082 19.5557C27.3915 17.1148 30.5738 16.2408 33.4608 17.3138C33.5343 17.3409 33.6098 17.3622 33.707 17.3937V10.7402H37.2177V9.00146H49.4958V10.7194H52.9214L52.919 33.4819ZM51.5724 32.0918V12.0723H48.13V10.3626H38.5595V12.0888H35.0796C35.0733 12.1565 35.0651 12.203 35.0651 12.2495C35.0651 14.1699 35.0622 16.0902 35.0719 18.0116C35.0719 18.1084 35.1551 18.2323 35.2363 18.2953C37.3524 19.9242 38.7432 22.9785 37.539 26.2135C36.808 28.176 35.8558 30.0242 34.8415 31.8448C34.7997 31.9194 34.7597 31.9944 34.7059 32.0927H42.7373V28.542H44.0955V32.0927L51.5724 32.0918ZM30.9724 35.578C31.0532 35.4647 31.0985 35.409 31.1355 35.348C31.9968 33.9225 32.8788 32.5096 33.7118 31.0677C34.6616 29.4214 35.5316 27.7358 36.191 25.9467C36.5733 24.91 36.7945 23.8559 36.5276 22.751C35.9765 20.4834 34.5957 18.9698 32.3479 18.4086C30.1 17.8474 28.1585 18.5297 26.6542 20.3077C25.6794 21.4591 25.2244 22.8255 25.4038 24.3454C25.4721 24.9216 25.6553 25.4945 25.8549 26.0431C26.5335 27.9111 27.4689 29.6567 28.4591 31.3693C29.2647 32.7692 30.1135 34.1457 30.9705 35.5761L30.9724 35.578Z"
        fill="black"
      />
      <Path
        d="M31.8295 35.576C31.1023 34.1457 30.3819 32.7676 29.6956 31.3693C28.8554 29.6552 28.0605 27.9096 27.4833 26.043C27.3141 25.4944 27.1587 24.9216 27.101 24.3454C26.9486 22.826 27.3347 21.4591 28.159 20.3076C29.4359 18.5296 31.0807 17.8469 32.9914 18.4086C34.9021 18.9702 36.0693 20.4834 36.5382 22.7509C36.7662 23.8554 36.5781 24.9095 36.254 25.9467C35.6942 27.7358 34.9555 29.4232 34.1499 31.0676C33.443 32.5096 32.6947 33.9244 31.9637 35.348C31.9367 35.4071 31.8978 35.4627 31.8295 35.576ZM34.6217 23.9149C34.6246 22.1016 33.3684 20.6083 31.8463 20.6156C30.3242 20.6228 29.0853 22.0963 29.0824 23.9023C29.0795 25.7084 30.3136 27.1882 31.8357 27.1949C33.3742 27.2008 34.6217 25.7341 34.6217 23.9149Z"
        fill="white"
      />
      <Path
        d="M47.5232 18.1345V19.4719H44.4746V18.1345H47.5232Z"
        fill="black"
      />
      <Path d="M47.5145 26.336H44.4727V24.9933H47.5145V26.336Z" fill="black" />
      <Path
        d="M42.3537 19.4747H39.2988V18.1282H42.3537V19.4747Z"
        fill="black"
      />
      <Path d="M42.358 24.9904V26.3321H39.2998V24.9904H42.358Z" fill="black" />
      <Path
        d="M44.4688 15.9949V14.6619H47.5178V15.9949H44.4688Z"
        fill="black"
      />
      <Path
        d="M44.4697 22.8579V21.5385H47.5217V22.8579H44.4697Z"
        fill="black"
      />
      <Path
        d="M42.3542 14.6691V15.9968H39.3047V14.6691H42.3542Z"
        fill="black"
      />
      <Path
        d="M39.2979 22.8594V21.5327H42.3537V22.8594H39.2979Z"
        fill="black"
      />
      <Path
        d="M34.2625 23.915C34.2614 24.3475 34.1755 24.7756 34.0097 25.1747C33.844 25.5738 33.6017 25.936 33.2967 26.2407C32.9917 26.5453 32.63 26.7864 32.2324 26.9501C31.8347 27.1137 31.4088 27.1968 30.9792 27.1945C30.1158 27.1896 29.2895 26.8403 28.6815 26.2231C28.0734 25.606 27.7332 24.7712 27.7354 23.9019C27.7386 23.0326 28.0826 22.1996 28.6924 21.5842C29.3023 20.9687 30.1287 20.6205 30.9922 20.6151C32.7856 20.6088 34.2659 22.1021 34.2625 23.915ZM32.9034 23.915C32.9057 23.409 32.7094 22.9226 32.3572 22.5617C32.005 22.2007 31.5255 21.9945 31.023 21.9879C29.9746 21.9762 29.0993 22.825 29.0916 23.8627C29.082 24.9464 29.9231 25.8223 30.9835 25.8324C32.0281 25.8455 32.8967 24.9773 32.9034 23.9179V23.915Z"
        fill="black"
      />
      <Path
        d="M32.9037 23.9179C32.897 24.9773 32.0284 25.8455 30.9838 25.8353C29.9258 25.8252 29.0823 24.9493 29.0919 23.8656C29.1005 22.8279 29.9749 21.9772 31.0233 21.9908C31.5258 21.9974 32.0053 22.2036 32.3575 22.5646C32.7097 22.9255 32.906 23.4119 32.9037 23.9179V23.9179Z"
        fill="white"
      />
    </G>
    <G clipPath="url(#clip1_1_3)">
      <Path
        d="M4.39613 35.5L0 38V36.4111L1.60387 35.5L0 34.5889V33L4.39613 35.5Z"
        fill="#E40046"
        fillOpacity={0.4}
      />
      <Path
        d="M10.9278 35.5L6.53613 38V36.4111L8.13554 35.5L6.53613 34.5889V33L10.9278 35.5Z"
        fill="#E40046"
        fillOpacity={0.4}
      />
      <Path
        d="M17.4635 35.5L13.0674 38V36.4111L14.6713 35.5L13.0674 34.5889V33L17.4635 35.5Z"
        fill="#E40046"
        fillOpacity={0.4}
      />
      <Path
        d="M23.9996 35.5L19.6035 38V36.4111L21.2074 35.5L19.6035 34.5889V33L23.9996 35.5Z"
        fill="#E40046"
        fillOpacity={0.4}
      />
    </G>
    <Defs>
      <ClipPath id="clip0_1_3">
        <Rect width={31} height={29} fill="white" transform="translate(24 9)" />
      </ClipPath>
      <ClipPath id="clip1_1_3">
        <Rect width={24} height={5} fill="white" transform="translate(0 33)" />
      </ClipPath>
    </Defs>
  </Svg>
);

export default PartersCitymallIcon;
